import React from 'react';

import { useWeb3Context } from '../../hooks/useWeb3Context';
import Button from '../Button/Button';
import ConnectButton from '../ConnectButton/ConnectButton';
import logo from '../../assets/images/ai-universe-logo-white.svg'

interface Props {
  onGalleryClick?: Function
  disableGalleryClick?: boolean
  disableConnectClick?: boolean
}

const Menu: React.FC<Props> = (props) => {
  const { hasToSwitchNetwork } = useWeb3Context();
  const { onGalleryClick, disableGalleryClick, disableConnectClick }: Props = props;

  const galleryOnClick = () => {
    if (onGalleryClick) {
      onGalleryClick();
    }

    if (window.innerWidth <= 768) {
      const body = document.body;
      if (body && body.classList.contains('menu-open')) {
        body.classList.add('menu-ani');
        setTimeout(() => {
          body.classList.remove('menu-open');
          body.classList.remove('menu-ani');
        }, 300)
      }
    }
  }

  return (
    <>
      <div id="navbar">
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="nav-toggle nav-trigger">
              <div className="nav-icon">
                <span></span>
              </div>
            </button>
            <a className="logo-main" href="/">
              <span className="logo-main-light">
                <img src={logo} alt="AI Univere" />
              </span>
            </a>
            <div className="nav-wrap">
              <nav id="nav-right">
                <div className="nav-connect">
                  <Button disabled={disableGalleryClick || Boolean(hasToSwitchNetwork)} className="button l-btn" onClick={galleryOnClick}>Gallery</Button>
                  <ConnectButton disabled={disableConnectClick} />
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Menu
